<template>
  <div class="nav lg-mx flex items-center" :class="{
    isMobile: isMobile()
  }">
    <div class="link" @click="$router.push({name: 'index'})">首页</div>
    <div class="icon"> > </div>
    <div class="link" @click="goModulePage">{{ moduleName }}</div>
    <div class="icon"> > </div>
    <div class="title">{{ title }}</div>
  </div>
</template>


<script>
/* eslint-disable */
import { mapGetters } from 'vuex'
import { isMobile } from '@/utils/index'

export default {
  data() {
    return {

    }
  },

  computed: {
    ...mapGetters({
      moduleList: 'moduleList'
    })
  },

  props: {
    moduleName: {
      type: String,
      default: ''
    },
    pid: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },

  methods: {
    isMobile,
    goModulePage() {
      const targetModule = this.moduleList.find(i => Number(i.id) === Number(this.pid))

      if (targetModule) {
        this.$router.push({
          name: targetModule.router
        })
      }
    }
  },
  created() {

  }
}
</script>

<style lang="scss" scoped>
.nav {
  margin-bottom: 43px;
  font-size: 14px;
  font-weight: 400;
  color: #878A95;

  &.isMobile {
    margin-bottom: 10px;
  }

  .title {
    color: $primary;
  }

  .icon {
    padding: 0 5px;
  }

  .link {
    cursor: pointer;
    transition: 0.2s;
    &:hover {
      color: $primary;
    }

    
  }
}
</style>